import React, { useState } from 'react';
import { Button, Box, Typography, Modal } from '@mui/material';
import ClienteAdd from './ClientAdd';
import ToastMessagge from '../../../components/utilities/ToastMessage';

export const ClienteAddModal = () => {
    const [openModal, setOpenModal] = useState(false);
    const [toastProps, setToastProps] = useState({
        open: false,
        msg: '',
        severity: 'info'
    });
    const handleChildCallback = (message) => {
        setOpenModal(false);

        setToastProps({
            open: true,
            msg: message,
            severity: 'success'
        });
    };
    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };
 
    

    return (
        <>
            <Button 
                variant="contained" 
                onClick={handleOpenModal} 
                sx={{ backgroundColor: 'green', '&:hover': { backgroundColor: 'darkgreen' } }}
            >
                Agregar Cliente
            </Button>

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ 
                    position: 'absolute', 
                    top: '50%', 
                    left: '50%', 
                    transform: 'translate(-50%, -50%)', 
                    width: '90%', 
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    bgcolor: 'background.paper', 
                    border: '2px solid #000', 
                    boxShadow: 24, 
                    p: 4 
                }}>
                    
                    <ClienteAdd onChildCallback={handleChildCallback} autotipificar={true} />
                    <Button 
                        color="secondary"
                        onClick={handleCloseModal}
                    >
                        Cancelar
                    </Button>
                </Box>
            </Modal>
            <ToastMessagge 
                            open={toastProps.open} 
                            msg={toastProps.msg} 
                            severity={toastProps.severity} 
                            onClose={() => setToastProps(prev => ({ ...prev, open: false }))} 
                        />

        </>
    );
};
